import { BarChart, DonutChart, SparklineChart } from "./Charts";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react'
import CandidateMaster from "../Candidate Master/CandidateMaster";

const Dashboard = () => {
    useEffect(() => {
        document.title = 'Viva HRMS: Dashboard'
        AOS.init(
            {
                duration: 1200,
            }
        );
    }, [])
    return (
        <>
            {/*
                <div className='container-fluid dashboard db-wrapper'>
                    <div className='row '>
                        <h2>Welcome To Viva HRMS</h2>
                    </div>
                </div>
            
                */}
            <CandidateMaster/>
        </>

    )
}
export default Dashboard;